'use client';

import type { Mutate, StoreApi, UseBoundStore } from 'zustand';
import { persist } from 'zustand/middleware';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface TradeSettingsState {
  allowRapidTrades: boolean;
  setAllowRapidTrades: (enabled: boolean) => void;
}

export const useTradeSettingsStore: UseBoundStore<
  Mutate<
    StoreApi<TradeSettingsState>,
    [['zustand/persist', Pick<TradeSettingsState, 'allowRapidTrades'>]]
  >
> = createTrackedStore<TradeSettingsState>('useTradeSettingsStore')(
  persist(
    (set) => ({
      allowRapidTrades: true,
      setAllowRapidTrades: (allowRapidTrades: boolean): void => {
        set({ allowRapidTrades });
      },
    }),
    {
      name: 'morfi-trade-settings',
      partialize: (state: TradeSettingsState): Pick<TradeSettingsState, 'allowRapidTrades'> => ({
        allowRapidTrades: state.allowRapidTrades,
      }),
    },
  ),
);
